import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import AppContext from "../../../context/AppContext";
import "../../../assets/css/gcadmin/adminlogin/AdminLoginPage.css";

const AdminResetPasswordPage = () => {
  const navigate = useNavigate();
  const { baseUrl } = useContext(AppContext);
  const [searchParams] = useSearchParams();

  const token = searchParams.get("token");
  const email = searchParams.get("email");

  const [visible, setVisible] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [linkInvalid, setLinkInvalid] = useState(false);

  useEffect(() => { setTimeout(() => setVisible(true), 60); }, []);

  useEffect(() => {
    if (!token || !email) {
      setLinkInvalid(true);
    }
  }, [token, email]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!newPassword || !confirmPassword) {
      setError("Please fill in both fields.");
      return;
    }
    if (newPassword.length < 6) {
      setError("Password must be at least 6 characters long.");
      return;
    }
    if (newPassword !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    setLoading(true);
    try {
      const res = await axios.post(`${baseUrl}/admin/auth/resetPassword`, {
        email,
        token,
        new_password: newPassword
      });

      if (res.data.success) {
        setDone(true);
      } else {
        setError(res.data.message || res.data.error || "Something went wrong. Please try again.");
      }
    } catch (err) {
      setError(err.response?.data?.message || err.response?.data?.error || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={`gcAdmin-login-page ${visible ? "gcAdmin-login-page--visible" : ""}`}>
      <div className={`gcAdmin-login-card ${visible ? "gcAdmin-login-card--visible" : ""}`}>

        <div className="gcAdmin-login-icon">
          <svg width="30" height="30" viewBox="0 0 24 24" fill="none"
            stroke="#ffffff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
          </svg>
        </div>

        {linkInvalid ? (
          <>
            <h2 className="gcAdmin-login-title">Invalid Link</h2>
            <p className="gcAdmin-login-subtitle">
              This password reset link is invalid or incomplete. Please request a new one.
            </p>
            <button
              className="gcAdmin-login-btn"
              onClick={() => navigate("/admin/forgot-password")}
            >
              Request New Link
            </button>
          </>
        ) : !done ? (
          <>
            <h2 className="gcAdmin-login-title">Reset Password</h2>
            <p className="gcAdmin-login-subtitle">Enter your new password below</p>

            {error && (
              <p className="gcAdmin-login-error">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                  <circle cx="12" cy="12" r="10"/>
                  <line x1="12" y1="8"  x2="12" y2="12"/>
                  <line x1="12" y1="16" x2="12.01" y2="16"/>
                </svg>
                {error}
              </p>
            )}

            <form className="gcAdmin-login-form" onSubmit={handleSubmit} noValidate>
              <div className="gcAdmin-login-field">
                <input
                  className="gcAdmin-login-input"
                  type="password"
                  placeholder="New Password"
                  value={newPassword}
                  onChange={e => setNewPassword(e.target.value)}
                  autoComplete="new-password"
                />
              </div>
              <div className="gcAdmin-login-field">
                <input
                  className="gcAdmin-login-input"
                  type="password"
                  placeholder="Confirm New Password"
                  value={confirmPassword}
                  onChange={e => setConfirmPassword(e.target.value)}
                  autoComplete="new-password"
                />
              </div>

              <button
                type="submit"
                className={`gcAdmin-login-btn ${loading ? "gcAdmin-login-btn--loading" : ""}`}
                disabled={loading}
              >
                {loading ? <span className="gcAdmin-login-spinner" /> : "Reset Password"}
              </button>
            </form>
          </>
        ) : (
          <>
            <h2 className="gcAdmin-login-title">Password Reset!</h2>
            <p className="gcAdmin-login-subtitle">
              Your password has been reset successfully. You can now log in with your new password.
            </p>
            <button
              className="gcAdmin-login-btn"
              onClick={() => navigate("/admin/login")}
            >
              Go to Login
            </button>
          </>
        )}

        <button className="gcAdmin-login-back" onClick={() => navigate("/")} type="button">
          ← Back to Home
        </button>

      </div>
    </div>
  );
};

export default AdminResetPasswordPage;